var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { injectIntl } from "@irati/utils/lang";
import Loading from "@irati/ui/src/Loading";
import authentication from "@irati/auth";
import teamService from "@irati/identity/services/teams";
import Button from "@irati/ui/src/Button";
import History from "@irati/utils/history";
import { hangPromise } from "@irati/utils/promise";
import { removeFromUserList } from "@irati/identity/apollo/query/UsersForBusiness";
import BackLink from "../../../../components/Teams/TeamList/BackLink";
import TeamUserList from "../../../../components/Teams/TeamUserList/TeamUserList";
import CreateTeam from "../../../../components/Teams/CreateTeam/CreateTeam";
import UserList, { INITIAL_USERLIST_VARIABLES } from "../../../../components/UserList";
import TeamAdminHeader from "../../../../components/AdminHeader/TeamAdminHeader";
var UserGroupUsersList = /** @class */ (function (_super) {
    __extends(UserGroupUsersList, _super);
    function UserGroupUsersList(props) {
        var _this = _super.call(this, props) || this;
        _this.userList = React.createRef();
        _this.adminHeader = React.createRef();
        _this.resetUserList = function () {
            var team = _this.state.team;
            if (team && _this.userList.current) {
                _this.userList.current.setVariables(INITIAL_USERLIST_VARIABLES(team.uuid));
            }
            if (_this.adminHeader.current) {
                _this.adminHeader.current.refetch();
            }
        };
        _this.removeUserFromTeam = function (variables, user) {
            var team = _this.state.team;
            if (team) {
                removeFromUserList(variables, user);
                teamService.removeUserFromTeam(team.uuid, user.uuid).then(function () { return _this.resetUserList(); });
            }
        };
        _this.openAddToTeamModal = function () {
            _this.setState({ isModalOpen: true });
        };
        _this.hideAddToTeamModal = function () {
            var team = _this.state.team;
            if (team) {
                _this.setState({ isModalOpen: false });
                _this.resetUserList();
            }
        };
        _this.handleBackToTeams = function () {
            History.push("/admin/products");
        };
        _this.state = {
            isModalOpen: false,
            isLoading: true,
            team: null,
            teamLoad: hangPromise()
        };
        return _this;
    }
    UserGroupUsersList.prototype.componentWillMount = function () {
        var _this = this;
        var variables = {
            tenantId: authentication.userTenant().uuid,
            teamId: this.props.match.params.teamId
        };
        var teamLoad = teamService.get(variables).then(function (team) {
            return _this.setState({ team: team });
        });
        this.setState({ teamLoad: teamLoad });
    };
    UserGroupUsersList.prototype.render = function () {
        var _this = this;
        var _a = this.state, isModalOpen = _a.isModalOpen, team = _a.team, teamLoad = _a.teamLoad;
        var formatMessage = this.props.formatMessage;
        return (React.createElement(Loading, { load: teamLoad },
            React.createElement(BackLink, { linkProps: { onClick: this.handleBackToTeams } }),
            React.createElement(TeamAdminHeader, { ref: this.adminHeader, team: team },
                React.createElement(Button, { className: "pull-right", primary: true, onClick: this.openAddToTeamModal }, formatMessage({ id: "admin.containers.teamUserList.nameCountAndButton.buttonText" }))),
            React.createElement(UserList, { ref: this.userList, teamId: this.props.match.params.teamId }, function (_a) {
                var users = _a.users, variables = _a.variables;
                return (React.createElement(TeamUserList, { team: team, users: users.results, removeUserFromTeam: function (user) { return _this.removeUserFromTeam(variables, user); } }));
            }),
            React.createElement(CreateTeam, { show: isModalOpen, currentTeam: team, onHide: this.hideAddToTeamModal })));
    };
    return UserGroupUsersList;
}(Component));
export default injectIntl(UserGroupUsersList);
